export default function Loader() {
  return (
    <div style={{
      height: "60vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "1.2rem"
    }}>
      ⏳ Ładowanie strony...
    </div>
  );
}
